/**
 * 팝오버 위치 계산 및 스크롤 추적 유틸리티
 */

/**
 * 트리거 요소 아래에 팝오버를 배치하는 함수
 */
export function placeBelow(triggerEl, popEl, offset = 8, margin = 8, zIndex = 1000) {
  if (!triggerEl || !popEl) return;

  const rect = triggerEl.getBoundingClientRect();

  // 측정 가능하게 잠깐 보이기
  popEl.style.position = "fixed";
  popEl.style.visibility = "hidden";
  popEl.style.display = "block";

  const pw = popEl.offsetWidth;
  const ph = popEl.offsetHeight;

  // 기본적으로 왼쪽 정렬 (버튼 왼쪽 끝에 맞춤)
  let leftRaw = rect.left;

  // 화면 오른쪽을 벗어나면 오른쪽 정렬로 변경
  if (leftRaw + pw > window.innerWidth - margin) {
    leftRaw = rect.right - pw;
  }

  // 최종 left 위치 (화면 경계 고려)
  const left = Math.max(margin, Math.min(leftRaw, window.innerWidth - pw - margin));

  // 기본적으로 아래쪽에 배치
  let top = rect.bottom + offset;

  // 화면 아래를 벗어나면 위쪽에 배치
  // if (top + ph > window.innerHeight - margin) {
  //   top = rect.top - ph - offset;
  // }

  popEl.style.left = `${left}px`;
  popEl.style.top = `${top}px`;
  popEl.style.zIndex = String(zIndex);
  popEl.style.visibility = "visible";
}

/**
 * 가로 스크롤이 가능한 부모 요소를 찾는 함수
 */
export function getHorizontalScrollParent(el) {
  let node = el?.parentElement || null;

  while (node) {
    const style = getComputedStyle(node);
    const overflowX = style.overflowX;
    const couldScroll = node.scrollWidth > node.clientWidth;

    if (
      couldScroll &&
      (overflowX === "auto" || overflowX === "scroll" || overflowX === "overlay")
    ) {
      return node;
    }

    node = node.parentElement;
  }

  return null;
}

/**
 * 팝오버 스크롤 추적 커스텀 훅
 */
import { useLayoutEffect, useCallback } from "react";

export function usePopoverScrollTracking(isOpen, triggerRef, popoverRef, trackXScroll = true) {
  const reposition = useCallback(() => {
    if (!isOpen || !triggerRef.current || !popoverRef.current) return;
    placeBelow(triggerRef.current, popoverRef.current, 8);
  }, [isOpen, triggerRef, popoverRef]);

  useLayoutEffect(() => {
    if (!isOpen) return;

    const trigger = triggerRef.current;
    const popover = popoverRef.current;

    if (!trigger || !popover) return;

    // 가로 스크롤 컨테이너 찾기
    const scroller = trackXScroll ? getHorizontalScrollParent(trigger) : null;

    // 최초 배치
    reposition();

    // 이벤트 리스너 등록
    const events = ["scroll", "resize"];
    const targets = [window];

    if (scroller && scroller !== window) {
      targets.push(scroller);
    }

    const handleEvent = () => {
      requestAnimationFrame(reposition);
    };

    targets.forEach((target) => {
      events.forEach((event) => {
        target.addEventListener(event, handleEvent, { passive: true });
      });
    });

    // 정리
    return () => {
      targets.forEach((target) => {
        events.forEach((event) => {
          target.removeEventListener(event, handleEvent);
        });
      });
    };
  }, [isOpen, reposition, trackXScroll]);

  return { reposition };
}
